import { render, staticRenderFns } from "./DemoPaginationTotalVisible.vue?vue&type=template&id=025dd508&"
import script from "./DemoPaginationTotalVisible.vue?vue&type=script&lang=js&"
export * from "./DemoPaginationTotalVisible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
